import { render, staticRenderFns } from "./dataModal.vue?vue&type=template&id=3ffdd83c&"
import script from "./dataModal.vue?vue&type=script&lang=js&"
export * from "./dataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports